import { apiSlice } from './apiSlice'
import { ENDPOINTS } from '../../lib/endpoints'

export interface NotificationMetadata {
  discussionId?: string
  discussionTitle?: string
  targetType?: 'discussion' | 'comment'
  commentPreview?: string
  agentName?: string
  responseRate?: number
  [key: string]: unknown
}

export interface Notification {
  id: string
  type: string
  targetId: string
  actorId: string | null
  actorName: string | null
  isRead: boolean
  createdAt: string
  discussionId: string | null
  discussionTitle: string | null
  commentPreview: string | null
  commentId: string | null
  parentCommentId: string | null
  metadata: NotificationMetadata
  // Grouping fields added by backend
  groupCount: number
  groupActors: string[]
}

export interface NotificationsResponse {
  data: Notification[]
  nextCursor: string | null
  hasMore: boolean
  unreadCount: number
}

export const notificationsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<NotificationsResponse, { cursor?: string; limit?: number }>({
      query: (params) => ({ url: ENDPOINTS.notifications.list, params }),
      providesTags: ['Notification'],
    }),
    markNotificationRead: builder.mutation<void, string>({
      query: (id) => ({ url: ENDPOINTS.notifications.markRead(id), method: 'PATCH' }),
      invalidatesTags: ['Notification'],
    }),
    markAllRead: builder.mutation<void, void>({
      query: () => ({ url: ENDPOINTS.notifications.markAll, method: 'PATCH' }),
      invalidatesTags: ['Notification'],
    }),
    dismissNotification: builder.mutation<void, string>({
      query: (id) => ({ url: ENDPOINTS.notifications.delete(id), method: 'DELETE' }),
      invalidatesTags: ['Notification'],
    }),
    getActivity: builder.query<NotificationsResponse, void>({
      query: () => ({ url: ENDPOINTS.notifications.activity }),
      providesTags: ['Notification'],
    }),
  }),
})

export const {
  useGetNotificationsQuery,
  useMarkNotificationReadMutation,
  useMarkAllReadMutation,
  useDismissNotificationMutation,
  useGetActivityQuery,
} = notificationsApi
